import React from 'react';
import { FormikContext } from 'formik';
const FormsContext = React.createContext(undefined);
export const FormsContextProvider = FormsContext.Provider;
export const useFormsContext = () => {
    const formik = React.useContext(FormikContext);
    const forms = React.useContext(FormsContext);
    if (!forms) {
        throw new Error('useFormsContext must be used inside of a component that is a child of the Forms provider');
    }
    return Object.assign(Object.assign({}, formik), forms);
};
//# sourceMappingURL=FormsContext.js.map